export default import.meta.ROLLDOWN_FILE_URL_yb$RA3fXWiW5Ks9qJ6pVEg